"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepeatTypeSelect = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var React = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var constants_1 = require("../../constants");
var datetime_1 = require("../../utils/datetime");
var DROPDOWN_WIDTH = 199;
var RenderRepeatTypeSelect = /** @class */ (function (_super) {
    tslib_1.__extends(RenderRepeatTypeSelect, _super);
    function RenderRepeatTypeSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isRepeatTypeItemSelected = function (item) {
            return item.id === _this.props.repeatType;
        };
        _this.getRepeatTypeItem = function (repeatType) {
            var _a = _this.props, intl = _a.intl, startDate = _a.startDate;
            return {
                id: repeatType,
                title: intl.formatMessage({ id: "dialogs.schedule.email.repeats.types." + repeatType }, {
                    day: datetime_1.getIntlDayName(intl, startDate),
                    week: datetime_1.getWeek(startDate),
                }),
            };
        };
        _this.getRepeatTypeItems = function () {
            return [constants_1.REPEAT_TYPES.DAILY, constants_1.REPEAT_TYPES.WEEKLY, constants_1.REPEAT_TYPES.MONTHLY, constants_1.REPEAT_TYPES.CUSTOM].map(_this.getRepeatTypeItem);
        };
        _this.onRepeatTypeChange = function (item) {
            _this.props.onChange(item.id);
        };
        return _this;
    }
    RenderRepeatTypeSelect.prototype.render = function () {
        var _this = this;
        var repeatItems = this.getRepeatTypeItems();
        var repeatTypeItem = repeatItems.find(this.isRepeatTypeItemSelected);
        return (React.createElement(sdk_ui_kit_1.Dropdown, { alignPoints: constants_1.DEFAULT_DROPDOWN_ALIGN_POINTS, className: "gd-schedule-email-dialog-repeat-type s-gd-schedule-email-dialog-repeat-type", renderButton: function (_a) {
                var toggleDropdown = _a.toggleDropdown;
                return (React.createElement(sdk_ui_kit_1.DropdownButton, { value: repeatTypeItem.title, onClick: toggleDropdown }));
            }, renderBody: function (_a) {
                var closeDropdown = _a.closeDropdown, isMobile = _a.isMobile;
                return (React.createElement(sdk_ui_kit_1.DropdownList, { width: DROPDOWN_WIDTH, items: repeatItems, isMobile: isMobile, renderItem: function (_a) {
                        var item = _a.item;
                        return (React.createElement(sdk_ui_kit_1.SingleSelectListItem, { title: item.title, onClick: function () {
                                _this.onRepeatTypeChange(item);
                                closeDropdown();
                            }, isSelected: repeatTypeItem.id === item.id }));
                    } }));
            }, overlayPositionType: "sameAsTarget", overlayZIndex: constants_1.DEFAULT_DROPDOWN_ZINDEX }));
    };
    return RenderRepeatTypeSelect;
}(React.PureComponent));
exports.RepeatTypeSelect = react_intl_1.injectIntl(RenderRepeatTypeSelect);
//# sourceMappingURL=RepeatTypeSelect.js.map